import { TWidget } from 'widgets/Widget';
import { scrollToTop } from '../toolbox/scroll';

/**
 * @param Widget Base widget for extending
 * @returns ContactUs widget
 */
function ContactUsClassCreator(Widget: TWidget) {
    /**
     * @category widgets
     * @subcategory content
     * @class ContactUs
     * @augments Widget
     * @classdesc Contact Us component with next features:
     * 1. Render success result content
     * 2. After rendering scroll to top if not in modal
     *
     * Contact Us component should contain `data-ref="contactUsFormWrapper"` with `data-is-in-modal="${pdict.isAjax}"` to indicate Is `contact us` component located in modal window
     *
     * @example <caption>Contact us component</caption>
     * <div class="b-contact" data-widget="contactUs">
     *   <div data-ref="contactUsFormWrapper" data-is-in-modal="${pdict.isAjax}">
     *       <form
     *           action="${pdict.actionUrl}"
     *           class="b-form m-contact-us"
     *           method="POST"
     *           name="contact-us"
     *           data-widget="ajaxform"
     *           data-widget-event-submit="onSuccessSubmit"
     *           data-event-submit.prevent="handleSubmit"
     *       >
     *          <div
     *             class="b-form-message b-message m-error"
     *             hidden="hidden"
     *             data-ref="errorMessageLabel"
     *             role="alert"
     *         ></div>
     *       ... form fields
     *       </form>
     *   </div>
     * </div>
     */
    class ContactUs extends Widget {
        /**
         * @description Render success message and scroll to top if content not in modal window
         * @param form - Ajax form widget instance
         * @param data - Contact us form submission response
        * @returns Promise object represents success message rendering result
         */
        onSuccessSubmit(form, data) {
            if (!data.success) {
                return Promise.resolve(null);
            }

            const isInModal = this.ref('contactUsFormWrapper').data('isInModal');

            return this.render(undefined, undefined, undefined, data.msg).then(()=> {
                if (!isInModal) {
                    scrollToTop();
                }
            });
        }
    }

    return ContactUs;
}

export type TContactUs = ReturnType<typeof ContactUsClassCreator>;

export type TContactUsInstance = InstanceType<TContactUs>;

export default ContactUsClassCreator;
